import React from 'react';

import { Divider } from 'redpoints-front-components/index';
import { LinkDataOfferListingForm } from 'redpoints-front-common/components';

import { translate } from '../../../helpers/languageHelper';

const IncidentDetailsLinkDataOfferListing = ({
  editable = true,
  offerListingLinkData,
  offerListingLinkMetadata,
  forceValidation,
  offerListingChange,
  offerListingValidate,
}) => (
  <>
    <Divider />
    <h3>{translate('reporting.incidentDetails.offerListing.title')}</h3>
    <LinkDataOfferListingForm
      editable={editable}
      forceValidation={forceValidation}
      offerListingLinkData={offerListingLinkData}
      offerListingLinkMetadata={offerListingLinkMetadata}
      onChange={offerListingChange}
      onValidate={offerListingValidate}
      shouldIgnoreMandatoryValidation
    />
  </>
);

export default IncidentDetailsLinkDataOfferListing;
